import React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
// import Button from '../../../../../../common/Button';

function UndoButton(props) {
  const notepad = useSelector(state => state.notepad);
  const handleUndoClick = useCallback(() => {
    notepad.canvasDraw.undo();
  }, [notepad]);

  return (
    <button className="bg_wht grn prev off" onClick={handleUndoClick}/> 
    // <Button
    //   className="del_note"
    //   style={{ marginLeft: 10 }}
    //   onClick={handleUndoClick}
    // >
    //   <img src={`${process.env.PUBLIC_URL}/static/images/icon/keypad/undo_icon.svg`} alt="" />
    // </Button>
  );
}

export default UndoButton;